import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import LeftBar from '../app/components/LeftBar/LeftBar';
import Searches from '../app/views/Searches/Searches';
import Groups from '../app/views/Groups/Groups';
import Users from '../app/views/Users/Users';
import Districts from '../app/views/Districts/Districts';
import Ridings from '../app/views/Ridings/Ridings';
import GoogleTrends from '../app/views/GoogleTrends/GoogleTrends';
import PollsMap from '../app/views/PollsMap/PollsMap';
import KyrpDashboard from '../app/views/KyrpDashboard/KyrpDashboard';
import Message from '../app/views/Message/Message';
import WardMap from '../app/components/Map/WardMap';
import CrimeMap from '../app/components/Map/CrimeMap';

const AppRoutes = ({ sessionState }) => {
  const action = useSelector((state) => state.action);
  const [loggingIn, setLoggingIn] = useState(false);
  const [loginAttempt, setLoginAttempt] = useState(false);

  useEffect(() => {
    if (action.loggingIn) {
      setLoginAttempt(true);
      setLoggingIn(true);
      return;
    }
    setLoginAttempt(false);
    setLoggingIn(false);
  }, [action]);

  return (
    <div className={loggingIn ? 'blur-frame' : !loginAttempt && !sessionState ? 'hidden' : ''}>
      <Router>
        <Routes>
          <Route exact path="/" element={<LeftBar />}>
            <Route index element={<Searches />} />
            <Route path="search_groups" element={<Groups />} />
            <Route path="users" element={<Users />} />
            <Route path="electoral_districts" element={<Districts />} />
            <Route path="ridings" element={<Ridings />} />
            <Route path="google_trends" element={<GoogleTrends />} />
            <Route path="polls_map" element={<PollsMap />} />
            <Route path="wards_map" element={<WardMap />} />
            <Route path="crime_map" element={<CrimeMap />} />
            <Route path="kyrp" element={<KyrpDashboard />} />
            <Route path="message/:id" element={<Message />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </div>
  );
};

export default AppRoutes;
